module.exports = __webpack_public_path__ + "img/CF.fa05ed15.svg";